/* unplugin-vue-components disabled */import script from "./DefaultInGameLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultInGameLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__